export const post = {
    title: "How to install GitHub Copilot in the CLI?",
    date: "October 25, 2026",
    readTime: "3 min read",
    author: "Aisha",
    content: `
    <p>I have been using GitHub Copilot Chat, but I recently started using GitHub Copilot in my CLI, and this is how you install it.</p>

    <p>Before you start, be sure to have Node.js 22 or later. This is very important because the GitHub Copilot CLI requires it.</p>

    <p>You can install GitHub Copilot CLI with npm, WinGet, or Homebrew. These are alternative installation methods. Use WinGet on Windows, Homebrew on macOS or Linux, or npm on any supported platform. Choose one of these methods:</p>

    <p>To install with npm, go to your terminal and paste:</p>
    <p><code>npm install -g @github/copilot</code></p>
    <img src="${require('@/assets/Screenshot 2026-10-25 at 14.19.12.png')}" alt="The npm install command in the terminal" style="max-width: 100%; margin: 1rem 0; border-radius: 8px;" />

    <p>On Windows, you can install with WinGet in PowerShell:</p>
    <p><code>winget install GitHub.Copilot</code></p>

    <p>On macOS or Linux, you can alternatively install with Homebrew:</p>
    <p><code>brew install --cask copilot-cli</code></p>
    <img src="${require('@/assets/Screenshot 2026-10-25 at 14.20.21.png')}" alt="The Homebrew install command in the terminal" style="max-width: 100%; margin: 1rem 0; border-radius: 8px;" />

    <p>Go to your terminal and select GitHub Copilot CLI.</p>
    <img src="${require('@/assets/Screenshot 2026-10-25 at 13.48.41.png')}" alt="Selecting GitHub Copilot CLI from the terminal menu" style="max-width: 100%; margin: 1rem 0; border-radius: 8px;" />

    <p>You will be prompted to install GitHub Copilot. Choose Yes.</p>
    <img src="${require('@/assets/Screenshot 2026-10-25 at 13.49.41.png')}" alt="The prompt to install GitHub Copilot CLI" style="max-width: 100%; margin: 1rem 0; border-radius: 8px;" />

    <p>If you get an error “Cannot find GitHub Copilot CLI”, be sure to update Visual Studio Code and Node.js to version 22 or later.</p>

    <p>Next, you will see something like this: Current, Sessions, Issues, Pull requests, and Gists.</p>
    <img src="${require('@/assets/Screenshot 2026-10-25 at 14.17.10.png')}" alt="GitHub Copilot CLI tabs in the terminal" style="max-width: 100%; margin: 1rem 0; border-radius: 8px;" />

    <p>Use slash commands to tell GitHub Copilot what you want it to do. In this picture, I use plan mode.</p>

    <img src="${require('@/assets/Screenshot 2026-10-25 at 15.36.54.png')}" alt="Using the plan command in GitHub Copilot CLI" style="max-width: 100%; margin: 1rem 0; border-radius: 8px;" />

    <p>Click Sessions to see your history locally, remotely, and so on.</p>
    <img src="${require('@/assets/Screenshot 2026-10-25 at 14.25.22.png')}" alt="The Sessions tab showing local and remote session history" style="max-width: 100%; margin: 1rem 0; border-radius: 8px;" />

    <p>Click the little icon to the right to always return to GitHub Copilot CLI or create a new session.</p>
    <img src="${require('@/assets/Screenshot 2026-10-25 at 14.22.11.png')}" alt="The GitHub Copilot CLI icon in the terminal sidebar" style="max-width: 100%; margin: 1rem 0; border-radius: 8px;" />


    <p>And this is how you set up GitHub Copilot in your CLI. For more information, visit the <a href="https://docs.github.com/en/copilot/how-tos/copilot-cli/set-up-copilot-cli/install-copilot-cli" target="_blank" rel="noopener noreferrer" style="color: #00bcd4;">GitHub Copilot CLI installation guide</a>.</p>
    `
};
